/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Reason_From_Stocktake_SurplusInputs */

const vi_pl_reason_from_stocktake_surplus = /** @type {(inputs: Pl_Reason_From_Stocktake_SurplusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm kê dư`)
};

/**

* @param {Pl_Reason_From_Stocktake_SurplusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_reason_from_stocktake_surplus = /** @type {((inputs?: Pl_Reason_From_Stocktake_SurplusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Reason_From_Stocktake_SurplusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_reason_from_stocktake_surplus(inputs)
});